import { str2Date } from "@/assets/js/utils.js";

const newsList = [
  {
    id: 1,
    title: "西安博物院挖掘馆藏，全力打造“福”文化",
    create_time: str2Date("2019/06/29 16:02"),
    content: `
<p>为了更好的促进历史传统文化的传承，发挥文化的价值，西安博物院充分利用馆藏的文物价值，与第三方公司合作，将“福”文化打造得如火如荼，非常值得业内借鉴。</p>
<p>2019年6月，西安博物院授权凯泰铭、咏时文化共同开发与销售福寿印类相关IP要素以及福寿印类的相关衍生产品。</p>
<img src="/images/news/1-1.jpg" />
<p>为了提升开发产品的文化内涵，西安博物馆特授权凯泰铭和咏时文化（以下简称第三方公司）可以使用甲方馆藏藏品资源来设计开发福寿印各种门类的文化创意产品，并拥有“敕赐荐福寺”匾额文字和“雁塔荐福”IP的使用权，同时授权该项目产品可以在包装上标注西安博物院出品及其西安博物院LOGO。</p>
<img src="/images/news/1-2.jpg" />
<p>有了庞大的馆藏资源支持，凯泰铭和咏时文化联手打造的一系列产品陆续面世销售。其中最具特色就是福寿印系列产品，一上市就以其厚重的历史底蕴和独具体验感而受到广大旅行者的青睐，络绎不绝的购买者非常热衷于亲自体验产品的盖印生成过程。这种沉浸式的产品体验感，非常符合当下景区产品的销售趋势，加上产品本身的历史渊源和吉祥寓意，更增强了产品的销售力。</p>
<img src="/images/news/1-3.jpg" />
<p>西安博物院的福寿印产品因为其独特的气场，逐渐成为博物院的软实力品牌IP。在博物院的各种历史纪念、品牌论坛、领导巡查等活动的进程中，体验福寿印成为每场活动中最为隆重的仪式内容。国家领导人以及各个行业的专家在考察和参观西安博物院的时候，都曾兴致盎然的感受了福寿印的拓印过程，也非常热衷手持“雁塔荐福”拍照留念。</p>
<p>西安博物院在弘扬历史文化方面的大胆探索，独辟蹊径的合作模式，适合所有历史文化类景区的深入研究和揣。特别是那些门票免费或者票价低的景区，探索出一条适合自身发展的文创产品研发和销售模式，是未来景区发展的大势所趋。</p>
<img src="/images/news/1-4.jpg" />
<img src="/images/news/1-5.jpg" />
<img src="/images/news/1-6.jpg" />
`
  },
  {
    id: 2,
    title: "故宫携手凯泰铭，启动第二代网络售检票系统建设",
    create_time: str2Date("2019/07/12 09:55"),
    content: `
<p>2019年07月12日，中国政府采购网上公布了《故宫博物院第二代网络售检票系统建设成交公告》。公告显示，故宫的二代售检票系统建设成交供应商为北京凯泰铭科技文化有限公司。</p>
<p>2019年7月19日，故宫在端门会议室召开了第二代网络售检票系统项目启动会。故宫的主管领导以及项目合作方凯泰铭公司的核心团队参加了项目启动会。</p>
<img src="/images/news/2-1.png" />
<p>启动会上，故宫主管信息化的领导详细说明了第二代票务系统建设的必要性，要求第二代系统必须解决第一代系统在使用过程中遇到技术问题，以提高管理效率和游客的满意度。随后，凯泰铭的技术团队在运营稳定性、票务预约的精准算法以及技术创新等方面做了专题讲解，并与故宫团队进行了针对性的技术答疑。</p>
<img src="/images/news/2-2.png" />
<p>当下，很多景区还处于原始的手工纸票时代，故宫超前的启动第二代网络售检票系统项目建设，将继续引领着旅游行业信息化、智慧化的发展方向和趋势。故宫在技术上的不断迭代创新与保留传统经典文化的治馆理念，形成了强烈鲜明的反差，也彰显了新时代的故宫管理层在景区智慧化方面的观念创新程度。</p>
`
  },
  {
    id: 3,
    title: "携手八达岭景区，打造大数据长城",
    create_time: str2Date("2019/10/13 15:57"),
    content: `
<p>2019年10月13日，八达岭长城景区举办“智慧景区数据分析平台一期建设项目”启动会。景区相关领导和项目承建方凯泰铭核心团队成员共同参加了启动会。</p>
<p>会上，八达岭长城景区的领导介绍了建设智慧景区意义和价值，并做了项目建设的总动员，要求景区各个部门高度配合项目合作方的各种工作，以实现建设现代智慧化景区的价值初衷。</p>
<img src="/images/news/3-1.png" />
<p>作为项目的中标合作方，凯泰铭科技公司的总经理做了项目开发建设的阶段性规划报告，对整个项目建设阶段的模块设计思路和计划做了详实的阐述，其核心技术运维工程师也对核心技术部分进行了分析与总结。</p>
<img src="/images/news/3-2.png" />
<p>八达岭长城在大数据分析系统方面的前瞻性战略布局，代表着现代景区的发展趋势和方向，值得国内旅游行业借鉴和学习。</p>
`
  },
  {
    id: 4,
    title: "抚远市委、市政府领导莅临考察凯泰铭",
    create_time: str2Date("2019/11/04 19:33"),
    content: `
<p>11月4日，抚远市委、市政府领导就城市旅游发展战略、文旅项目开发等相关议题莅临考察了凯泰铭科技公司。</p>
<img src="/images/news/4-1.png" />
<p>考察团队在市委书记周宏、郑市长的带领下，参观了凯泰铭提供技术支持的天安门城楼票务系统、故宫信息化建设项目，对全网票务实名制、购票流程以及高峰限流等相关工作内容，做了详细的调研。凯泰铭总经理带领核心团队全程陪同，并给予现场讲解。</p>
<img src="/images/news/4-2.png" />
<p>参观结束后，抚远市委市政府领导参加了在故宫端门会议室内召开的抚远市旅游发展战略研讨会。会上，凯泰铭的抚远项目团队以《抚远市旅游品牌战略定位暨传播方案》为题做了专题报告。报告非常详细的分析了抚远市的旅游行业发展现状、痛点分析、未来的机会点，并提出经过系列论证后的品牌定位、IP打造、景区引流、传播策略等相关内容。抚远市委领导给予报告高度好评，并与项目组成员进一步探讨了与城市旅游发展策略相关的一些议题。</p>
<img src="/images/news/4-3.png" />
<p>会后，抚远市相关领导与凯泰铭董事长、总经理等高层举办了小范围的讨论会，就抚远市旅游地产、招商引资以及城市旅游规划等问题进行了深层次的交流与研讨，并就下一步的合作推进思路和方向等工作内容达成了基本共识。</p>
`
  },
  {
    id: 5,
    title: "八达岭长城大数据系统正式上线，景区管控水平再上新台阶",
    create_time: str2Date("2020/4/24 08:58"),
    content: `
<p>4月24日上午，八达岭长城景区举办了大数据系统的项目成果专题汇报会。</p>
<img src="/images/news/5-1.jpg" />
<p>参加本次汇报会议有八达岭长城特区办的主要领导、相关部门负责人以及项目承建方北京凯泰铭科技文化有限公司的核心团队，负责项目汇报和演示的是凯泰铭科技公司的项目经理李乐伦。</p>
<img src="/images/news/5-2.jpg" />
<img src="/images/news/5-3.jpg" />
<p>李经理对整个项目系统的功能进行了详细的讲解，包括景区系统服务器、数据分析平台架构、数据分析门户、手机端展示、管理后台、维保措施以及后续的升级建议等内容。新系统上线后，可实现景区精细化管理需要的新功能：对购票人数、购票渠道、支付方式以及观众籍贯、性别、年龄等资料进行汇总分析；对进入景区参观人数、主要景点人流密集程度以及离园人数进行有效统计；监控停车场车位车型情况、异常情况记录等安全功能。</p>
<img src="/images/news/5-4.jpg" />
<p>项目汇报过程中，大数据显示系统的功能设计内容引起了景区领导的高度重视，汇报工作进入到了热烈讨论阶段。期间，景区主要领导和各个部门主任都发表了各自的看法，并提出一些后续调整和系统升级的建议。凯泰铭总经理汪波和项目经理李乐伦对景区领导的建议进行了逐一细致的回复。讨论过程中，双方敲定了在疫情期间进行无人机拍摄等相关事宜。随后在八达岭大数据指挥中心，李乐伦为景区领导和工作人员现场演示了大数据实时系统，从功能到操作模式，从PC端到手机端都进行了详细的讲解。</p>
<img src="/images/news/5-5.jpg" />
<p>在汇报会的总结阶段，景区领导给予整个项目以高度认可与评价。这意味着历时半年的从论证、建设到不断完善的大数据系统正式上线，开始履行景区精细化管理的战略责任。这些新功能在疫情期间得以充分实现，显得更有其实用价值，不但使得景区的整体管理水准得到了质的提升，在精细化管控方面也一步到位跃居于国内景区的领先地位。</p>
`
  },
  {
    id: 6,
    title: "前行无惧，来兹可期 —— 北京凯泰铭科技文化发展有限公司牛年寄语",
    create_time: str2Date("2021/1/27 15:58"),
    content: `
<p>告别庚子，迎来牛年。在这辞旧迎新之际，凯泰铭公司团队一展雄风，以绝对的综合优势连中多标，奠定了牛年的开门大局，牛转乾坤的气势宏大而又磅礴。</p>
<p>一月份，经过商务中心、运维中心、研发中心等各部门群策群力的不懈努力之下，公司一连中标了三个国内5A景区的信息化项目，其中包括恭王府售票系统运维服务项目、八达岭长城售票系统运维服务项目以及武侯祠博物馆智能票务线上预约系统项目。这份成绩来之不易，特别是在疫情常态化、文旅行业整体不景气的大环境之下，更显得弥足珍贵！不但值得我们为之欣慰，更应该为这些项目付出过心血汗水、经常加班的团队成员予以点赞与褒奖！</p>
<p>回首过去的一年，那些历经的艰难与困窘让人感慨万千！初期景区关停，所到之处，满目萧索与荒凉，后来开始预约限流，景区开始逐渐呈现复苏的景象。而六月的新发地疫情，又让一切复苏回到从前，那种创业者的内心感触，也是难以比拟形容的！可以想象，在这样到处出示健康码的社会环境下，我们的商务开发客户、运维实施项目会遇到多少艰难，团队因为黄码被隔离在宾馆吃一周泡面、无法回到燕郊住在公司、因为孩子太小出差后无法回家等等曾经都是常态。</p>
<p>公司为故宫博物院票务系统服务的社会化服务中心，有一支非常精干而又年轻的团队。因为团队负责人对全网票务预售系统的业务专精，在其带领下，整个团队的服务质量多次受到故宫博物院官方的高度肯定。在五一假期和六月新发地疫情非常严峻期间，社会化团队也面临着巨大的工作压力。一边是孩子尚小、老少同住的家庭，或者人生风华正茂的单身员工，另一边是每天高达3万人、来自世界各地的旅游人群，工作环境的复杂性、危险性考验着每一个员工。</p>
<p>最终，团队的凝聚力焕发出耀眼的光芒，整个团队谨遵疫情防控政策，严格要求，准确操作，整齐协调而又高质量的完成了故宫博物院的日常参观接待以及“丹宸永固：紫禁城建成六百年”大型展览的票务线下综合服务工作。如此繁重的线下服务工作，整个团队工作无一例失误，无一起投诉，委实不易，值得褒奖！</p>
<p>为三亚免税店信息化系统执行开发任务的团队，是公司抽调的核心骨干组成的精锐之师。因为业务的现实需要，所有人员需要长期驻场三亚执行开发和难题攻关等相关工作。该项目系统庞大而又复杂，很多模块需要超越以往的高度进行创新，导致开发前期工作遇到很多困难，整个项目陷入进退两难的尴尬境地。最终，经过不断的论证和剧烈的研讨调整，整个团队克服了重重困难，实现了团队技术水准的涅槃与超越。目前，整个项目团队，正在通宵达旦的开发进程之中。该项目的开发成功，将预示着我们的团队在免税系统开发领域达到了新的高度。</p>
<p>因为有了这些担当和付出，所以才有了厚积薄发的收获！也正因为有了这样的团队，才能让我们有信心看得更远，走得更稳。</p>
<p>疫情期间，整个文旅行业没了业绩支撑，只能靠历史积累延续企业的使命。于是，行业内很多公司开始了降薪裁员等方式自救。为了吸纳流转出来的高端人才，我们选择逆向而行，敞开门楣，广纳贤良，聘用了很多行业优秀公司流失的高素养人才，从扎瓦、奈特、幽艾、产品到前端，公司的团队技能更加互补，队形更加齐整。</p>
<p>经过一年的努力布局，公司整体格局和架构发生了很大变化。公司的成都合资公司、西安子公司、西安分公司都已经初具规模，新的业务和研发布局都在紧张有序的进行中，武侯祠项目、兵马俑项目、西安博物院项目，就是成都合资公司和西安分公司两个团队的努力成果，未来西安子公司将成为公司新的技术开发基地；公司的手办事业部取得了卓有成效的进展，参股公司次元天网开发的细胞平台也正在紧锣密鼓的测试之中，第一款山海经系列经典手办产品已经进入打磨监修阶段之中，细胞平台上线后，将成为国内首家集社交、电商为一体的、专业化的手办类垂直综合交流与交易平台。</p>
<p>与此同时，公司的云平台项目也加速推进，一盘更大的棋从此走出论证阶段，开始布局和实施，最终实现公司一站式全产业链化的业务体系，形成集全网票务系统开发、大数据系统开发、云平台生态系统、高级网络和安全运维以及旅游文创手办为一体的技术文化综合生态服务系统。</p>
<p>通过一年的调整、升级和布局，公司的管理更加流畅，人才结构也更加互补和高效，虽然成本大幅度提升，但战斗力却有了质的飞跃。新岁之初，项目开发屡战屡胜的实践告诉我们：一个企业最大的财富，是充满凝聚力和战斗力的团队！</p>
<p>回首创业历程，2019年，凯泰铭公司历经初创、积累与成长；2020年经历磨难、负重与扩张。在这逆风飞扬的创业过程中，目标清晰、眼神坚毅、剑指华山一条路是我们唯一的IP风格，我们曾经回头反思过，却从未停歇、也毫不懈怠，一直向前、一直向上！</p>
<p>回首创业历程，期间所有经历的欣慰与波折，包括疫情之下的激昂、坚韧和迸发，像一首充满着岁月淬炼的悠扬赞歌，在无声的褒奖着我们的团结、勤奋和创新，也在包容警示着我们的懵懂、躁动、急于事功和偶尔的偏执，让我们在前行中经历磨难，在磨难中快速成长，在成长中践行梦想！</p>
<p>新的一年，我们的团队将更加忙碌，精神更加焕发，未来更值得描述和渲染！我们坚信，前景会越来越好！为此我们以枕戈待旦迎接每一个挑战，也必将举杯飞天为胜利庆功同祝！</p>
<p>还有一周时间，我们将迎来立春的日子。这在当下，不知道有多少人为之期盼，并赋予她独特的意义：万物复苏、春暖花开，迎接新生…….而此刻，北京的天高远而云蔚蓝，感觉比以往更加澄澈。充满梦想与憧憬的2021年已经正式拉开帷幕，新的一年，江湖必将再起波澜！</p>
<p>让我们为那些通宵达旦为梦想而战的同仁们点赞和鼓掌！与你们同行，给了我们牛气冲天的自信，强化了我们精诚所至的信仰，更赋予我们决战江湖的气魄！</p>
<p>愿此牛年寄语，犹如征前檄文，激励我们携手共勉，同创未来！</p>
`
  }
];

export default newsList;
